import { render, staticRenderFns } from "./LatarBelakang.vue?vue&type=template&id=047f3aed&lang=pug&"
import script from "./LatarBelakang.vue?vue&type=script&lang=js&"
export * from "./LatarBelakang.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports